import { combineReducers } from 'redux';
import formData from './formData';

export default combineReducers({ formData });
